export const searchResults = state => state.search.searchResults;
export const searchIsLoading = state => state.search.isLoading;
